import React, { Component } from "react";
import styled from "styled-components";
import { RotateSpinLoader } from "react-css-loaders2";

class BlockLoader extends Component {
  render() {
    const {
      isLoading,
      color,
      size,
      children,
      isEmpty,
      noRowsText
    } = this.props;

    if (isEmpty) {
      return <Wrapper>{noRowsText}</Wrapper>;
    }

    if (isLoading) {
      return (
        <Wrapper>
          <StyledLoader color={color || "#000"} size={size || 2} />
        </Wrapper>
      );
    }
    return children;
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 2px;
  height: 200px;
  width: 100%;
`;
const StyledLoader = styled(RotateSpinLoader)`margin: 0;`;

export default BlockLoader;



// WEBPACK FOOTER //
// ./src/components/BlockLoader.js